import { render, staticRenderFns } from "./CustomThemeMaker.vue?vue&type=template&id=c1f64d12"
import script from "./CustomThemeMaker.vue?vue&type=script&lang=js"
export * from "./CustomThemeMaker.vue?vue&type=script&lang=js"
import style0 from "./CustomThemeMaker.vue?vue&type=style&index=0&id=c1f64d12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports